/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Error_No_AvailabilityInputs */

const en_booking_error_no_availability = /** @type {(inputs: Booking_Error_No_AvailabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No availability on this day.`)
};

const es_booking_error_no_availability = /** @type {(inputs: Booking_Error_No_AvailabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay disponibilidad este día.`)
};

const de_booking_error_no_availability = /** @type {(inputs: Booking_Error_No_AvailabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An diesem Tag sind keine Termine frei.`)
};

const zh_booking_error_no_availability = /** @type {(inputs: Booking_Error_No_AvailabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这一天没有可预约的时间。`)
};

const ar_booking_error_no_availability = /** @type {(inputs: Booking_Error_No_AvailabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا توجد مواعيد متاحة في هذا اليوم.`)
};

const fr_booking_error_no_availability = /** @type {(inputs: Booking_Error_No_AvailabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune disponibilité ce jour-là.`)
};

const vi_booking_error_no_availability = /** @type {(inputs: Booking_Error_No_AvailabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày này không còn lịch trống.`)
};

const sw_booking_error_no_availability = /** @type {(inputs: Booking_Error_No_AvailabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakuna nafasi siku hii.`)
};

const th_booking_error_no_availability = /** @type {(inputs: Booking_Error_No_AvailabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่มีเวลาว่างในวันที่เลือก`)
};

const bs_booking_error_no_availability = /** @type {(inputs: Booking_Error_No_AvailabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nema slobodnih termina ovog dana.`)
};

const ja_booking_error_no_availability = /** @type {(inputs: Booking_Error_No_AvailabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この日は空きがありません。`)
};

const ko_booking_error_no_availability = /** @type {(inputs: Booking_Error_No_AvailabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 날짜에는 예약 가능한 시간이 없습니다.`)
};

const pt_booking_error_no_availability = /** @type {(inputs: Booking_Error_No_AvailabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem disponibilidade neste dia.`)
};

const it_booking_error_no_availability = /** @type {(inputs: Booking_Error_No_AvailabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna disponibilità in questo giorno.`)
};

const sv_booking_error_no_availability = /** @type {(inputs: Booking_Error_No_AvailabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inga lediga tider denna dag.`)
};

const nl_booking_error_no_availability = /** @type {(inputs: Booking_Error_No_AvailabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen beschikbaarheid op deze dag.`)
};

const da_booking_error_no_availability = /** @type {(inputs: Booking_Error_No_AvailabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen ledige tider denne dag.`)
};

const nb_booking_error_no_availability = /** @type {(inputs: Booking_Error_No_AvailabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen ledige timer denne dagen.`)
};

const fi_booking_error_no_availability = /** @type {(inputs: Booking_Error_No_AvailabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tälle päivälle ei ole vapaita aikoja.`)
};

const pl_booking_error_no_availability = /** @type {(inputs: Booking_Error_No_AvailabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak wolnych terminów w tym dniu.`)
};

const ru_booking_error_no_availability = /** @type {(inputs: Booking_Error_No_AvailabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`На этот день нет свободного времени.`)
};

const tr_booking_error_no_availability = /** @type {(inputs: Booking_Error_No_AvailabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu gün için uygun saat yok.`)
};

const hi_booking_error_no_availability = /** @type {(inputs: Booking_Error_No_AvailabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस दिन कोई समय उपलब्ध नहीं है।`)
};

const id_booking_error_no_availability = /** @type {(inputs: Booking_Error_No_AvailabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada jadwal tersedia pada hari ini.`)
};

const ms_booking_error_no_availability = /** @type {(inputs: Booking_Error_No_AvailabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada slot kosong pada hari ini.`)
};

const cs_booking_error_no_availability = /** @type {(inputs: Booking_Error_No_AvailabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`V tento den nejsou volné termíny.`)
};

const el_booking_error_no_availability = /** @type {(inputs: Booking_Error_No_AvailabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Δεν υπάρχει διαθεσιμότητα αυτή την ημέρα.`)
};

const he_booking_error_no_availability = /** @type {(inputs: Booking_Error_No_AvailabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אין זמינות ביום הזה.`)
};

const af_booking_error_no_availability = /** @type {(inputs: Booking_Error_No_AvailabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen beskikbaarheid op hierdie dag nie.`)
};

const hu_booking_error_no_availability = /** @type {(inputs: Booking_Error_No_AvailabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ezen a napon nincs szabad időpont.`)
};

/**
* | output |
* | --- |
* | "No availability on this day." |
*
* @param {Booking_Error_No_AvailabilityInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const booking_error_no_availability = /** @type {((inputs?: Booking_Error_No_AvailabilityInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Error_No_AvailabilityInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_booking_error_no_availability(inputs)
	if (locale === "de") return de_booking_error_no_availability(inputs)
	if (locale === "zh") return zh_booking_error_no_availability(inputs)
	if (locale === "ar") return ar_booking_error_no_availability(inputs)
	if (locale === "fr") return fr_booking_error_no_availability(inputs)
	if (locale === "vi") return vi_booking_error_no_availability(inputs)
	if (locale === "sw") return sw_booking_error_no_availability(inputs)
	if (locale === "th") return th_booking_error_no_availability(inputs)
	if (locale === "bs") return bs_booking_error_no_availability(inputs)
	if (locale === "ja") return ja_booking_error_no_availability(inputs)
	if (locale === "ko") return ko_booking_error_no_availability(inputs)
	if (locale === "pt") return pt_booking_error_no_availability(inputs)
	if (locale === "it") return it_booking_error_no_availability(inputs)
	if (locale === "sv") return sv_booking_error_no_availability(inputs)
	if (locale === "nl") return nl_booking_error_no_availability(inputs)
	if (locale === "da") return da_booking_error_no_availability(inputs)
	if (locale === "nb") return nb_booking_error_no_availability(inputs)
	if (locale === "fi") return fi_booking_error_no_availability(inputs)
	if (locale === "pl") return pl_booking_error_no_availability(inputs)
	if (locale === "ru") return ru_booking_error_no_availability(inputs)
	if (locale === "tr") return tr_booking_error_no_availability(inputs)
	if (locale === "hi") return hi_booking_error_no_availability(inputs)
	if (locale === "id") return id_booking_error_no_availability(inputs)
	if (locale === "ms") return ms_booking_error_no_availability(inputs)
	if (locale === "cs") return cs_booking_error_no_availability(inputs)
	if (locale === "el") return el_booking_error_no_availability(inputs)
	if (locale === "he") return he_booking_error_no_availability(inputs)
	if (locale === "af") return af_booking_error_no_availability(inputs)
	if (locale === "hu") return hu_booking_error_no_availability(inputs)
	return en_booking_error_no_availability(inputs)
});